import React from "react";

import { Chip, ChipWrapper } from "components/Chip";

interface Label {
  id: string;
  name: string;
}

interface LabelsRendererParams {
  value: string | null;
  data: {
    business?: {
      labels?: Label[];
    };
  };
}

export function LabelsRenderer({ value, data }: LabelsRendererParams) {
  if (!value) {
    return null;
  }
  return (
    <ChipWrapper>
      {data?.business?.labels?.map(label => (
        <Chip key={label.id}>{label.name}</Chip>
      ))}
    </ChipWrapper>
  );
}
